export default {
  black: '#000',
  almostBlack: '#333',
  slate: '#777',
  mediumGray: '#9a9a9a',
  chrome: '#cbcbcb',
  lightGray: '#f1f1f1',
  whiteDove: '#f7f7f7',
  white: '#fff',
  indigo: '#28325a',
  skyBlue: '#5196cb',
  skyBlue2: '#2e8bd2',
  blue: '#f7fcfe',
  goldenrod: '#ffbd33',
  goldenrod2: '#eca716',
  lightYellow: '#fee3b7',
  fern: '#6fcf97',
  fern2: '#3eb670',
  poppy: '#fe4237',
  poppy2: '#f32014',
  rose: '#fc9688',
  rose2: '#e77',
  tangerine: '#f78301',
  tangerine2: '#e17700',
  lavender: '#d4b6dd',
  lavender2: '#cb87e0',
  oceanGreen: '#49BA84',
  transparent: '#FFFFFF00',
  indigoDye: '#064961',
  cosmicLatte: '#dcf6e9',
}
